// extracted by mini-css-extract-plugin
export default {"fieldsContainer":"tariffAccordionTypography_fieldsContainer__XgQIg"};